module.exports = __webpack_public_path__ + "static/haard-3-297ee87fadd39e584cdbdf43990d0dc1.jpg";